import SearchDescriptionViewModel from "../ViewModels/Controls/SearchDescriptionViewModel";
import Overlay from "./Overlay";
import ComponentManager from '@/Management/ComponentManager';
import { ISearchGridDTO } from "coreframetypings/dto";
import Utilities from '@/Utility/Utilities';
import * as StringFormatter from '@/Utility/StringFormatter';

interface ITooltipPosition {
    leftPosition: number;
    calloutClass: string;
}
export default class SearchDescription extends Overlay {

    private hoveredPdoId: string = '';
    public lastMouseX: number = undefined;
    public lastMouseY: number = undefined;
    public currentMouseX: number = -1;
    public currentMouseY: number = -1;
    private resultExpander: JQuery<HTMLElement>;

    public constructor(protected viewModel: SearchDescriptionViewModel, element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) return this.jQueryControl;

        this.jQueryControl = super.getControl();
        this.defineSubscription(this.viewModel.searchKeyword, (searchKeyword) => this.describeSearchResult(searchKeyword as string, this.viewModel?.hovered()));
        this.defineSubscription(this.viewModel.hovered, (hovered) => this.describeSearchResult(this.viewModel?.searchKeyword(), hovered as ISearchGridDTO));
        this.registerMouseMoveHandler();
        this.registerShowHandler();

        return this.jQueryControl;
    }

    private registerMouseMoveHandler(): void {
        this.resultExpander = $(document).find('.result-expander');
        if (!this.resultExpander.length) return;

        this.addEventHandler('mousemove', this.resultExpander, (event: MouseEvent) => {
            this.currentMouseX = event.pageX;
            this.currentMouseY = event.pageY;

            const widget = this.widget();
            const isVisible = widget.popup?.visible() ?? false;
            const tooltipWidth = isVisible ? (widget.popup?.element?.outerWidth() ?? 0) : 0;


            if (this.checkMouseAndShouldHide(tooltipWidth)) {
                widget.hide();
            }
        });

        //Manuelles Ausblenden des Tooltips sobald die Maus den ResultExpander verl�sst
        this.addEventHandler('mouseleave', this.resultExpander, (event: MouseEvent) => {
            const relatedTarget = event.relatedTarget as Element;

            //Verhindert, dass sich der Tooltip beim wechsel der gehoverten td schlie�t
            const tooltipContainer = this.widget()?.popup?.element?.closest('.k-animation-container')[0];
            if (tooltipContainer && tooltipContainer.contains(relatedTarget)) {
                return;
            }

            this.widget()?.hide();
            this.lastMouseX = undefined;
            this.lastMouseY = undefined;
        });
    }

    /**
     * Aktualisiert die Anzeige des Tooltip entsprechend der Mausposition.
     */
    private registerShowHandler(): void {
        const widget = this.widget();
        widget?.bind('show', () => {
            this.adjustTooltipPositionAndSize(widget);
        });
    }

    public computeTooltipLeft(tooltipWidth: number, offset: number = 30): ITooltipPosition {
        const mouseX = this.currentMouseX;
        const windowWidth = window.innerWidth;

        // Standardmaessig Tooltip rechts vom Mauszeiger anzeigen
        let leftPosition = mouseX + offset;
        let calloutClass = 'k-callout k-callout-w';

        const leftSpace = mouseX - offset;
        const leftOffset = leftSpace - tooltipWidth;

        const doesntFitRight = leftPosition + tooltipWidth > windowWidth;
        const fitsLeft = leftOffset >= 0;
        const moreSpaceLeft = leftSpace > windowWidth - leftSpace && leftOffset < 0;

        // 1. Wenn rechts nicht genug Platz fuer den Tooltip ist, aber links passt,
        // dann der Tooltip links vom Mauszeiger anzeigen
        // 2. Wenn die Breite des Tooltips groesser ist als der Abstand nach links und rechts,
        // dann wird dort angezeigt, wo mehr Platz ist.
        if (doesntFitRight && fitsLeft || moreSpaceLeft) {
            leftPosition = leftOffset;
            calloutClass = 'k-callout k-callout-e';
        }

        return { leftPosition, calloutClass };
    }


    public checkMouseAndShouldHide(tooltipWidth: number): boolean {
        // Erster Aufruf: lastMouse initialisieren, noch nicht verstecken
        if (this.lastMouseX === undefined || this.lastMouseY === undefined) {
            this.lastMouseX = this.currentMouseX;
            this.lastMouseY = this.currentMouseY;
            return false;
        }

        const tolerance = 30;
        const movedLeft = this.currentMouseX < this.lastMouseX - tolerance;
        const movedUp = this.currentMouseY < this.lastMouseY - tolerance;
        const movedDown = this.currentMouseY > this.lastMouseY + tolerance;
        const movedPastTooltip = tooltipWidth > 0 &&
            this.currentMouseX > this.lastMouseX + tooltipWidth + tolerance;

        const shouldHide = movedLeft || movedUp || movedDown || movedPastTooltip;

        // lastMouse nur bei relevanter Bewegung aktualisieren,
        // damit kleine Bewegungen akkumulieren k�nnen
        const beyondTolerance = Math.abs(this.currentMouseX - this.lastMouseX) > tolerance
            || Math.abs(this.currentMouseY - this.lastMouseY) > tolerance;

        if (beyondTolerance) {
            this.lastMouseX = this.currentMouseX;
            this.lastMouseY = this.currentMouseY;
        }

        return shouldHide;
    }

    private describeSearchResult(searchKeyword: string, hovered: ISearchGridDTO): void {
        if (Utilities.isNullOrUndefinedOrBlank(searchKeyword) ||
            Utilities.isNullOrUndefinedOrBlank(hovered)) return;

        const $target = $(hovered.target) as JQuery<HTMLElement>;
        const widget = this.widget();

        if (this.hoveredPdoId === hovered.pdoId) {
            widget.show($target);
            return;
        }

        this.updateWidgetContent(widget, '');

        this.viewModel.describeSearchResult(hovered).then((description: any) => {
            if (this.isDisposed) return;

            if (this.hoveredPdoId === hovered.pdoId) return;

            this.hoveredPdoId = hovered.pdoId;

            const content = this.createContent(searchKeyword, description);
            const widget = this.widget();

            widget['tableRowCount'] = content.find('tr').length;

            //Knockout-Kendo-Binding ist an dieser Stelle zu langsam, und der Tooltip wird angezeigt,
            //bevor der Content von der Funktion Watch aktualisiert wird.
            //Daher aktualisieren wir den Inhalt manuell.
            this.updateWidgetContent(widget, content);

            const $target = $(hovered.target) as JQuery<HTMLElement>;
            widget.show($target);
        });
    }

    private updateWidgetContent(widget: kendo.ui.TooltipExt, content: string | JQuery<HTMLElement>): void {
        const options = widget.options as kendo.ui.TooltipOptionsExt;
        options.content = content;
        widget.refresh();
    }

    private createContent(searchKeyword: string, description: any): JQuery<HTMLElement> {
        let keys = _.keys(description);

        let rows = [
            this.createRow('<strong>' + this.viewModel.descriptionHeader + '</strong>',
                '<strong>' + this.viewModel.valueHeader + '</strong>')
        ];

        for (let i = 0; i < keys.length; i++) {
            rows.push(this.createRow(StringFormatter.escapeHtml(keys[i], true), StringFormatter.escapeHtml(description[keys[i]], true), searchKeyword));
        }

        let table = this.createTable(rows);

        return table;
    }

    private createTable(rows: Array<JQuery<HTMLElement>>): JQuery<HTMLElement> {
        let table = $('<table>');

        for (let i = 0; i < rows.length; i++) {
            table.append(rows[i]);
        }

        return table;
    }

    private createRow(left: string, right: string, value?: string): JQuery<HTMLElement> {
        let row = $('<tr></tr>');

        const splitContent = right.split(/\s+/) ?? [];
        const charAmount = right.length;

        // 500 Woerter / 750 Zeichen sollten gut innerhalb des Tooltips angezeigt werden koennen
        if (splitContent.length < this.viewModel.maxWordsToDisplay && charAmount < this.viewModel.maxCharactersToDisplay) {
            this.buildContentForRow(left).appendTo(row);
            this.buildContentForRow(right).appendTo(row).highlight(value);

            return row;
        }

        if (value === '*') {
            if (charAmount > this.viewModel.maxCharactersToDisplay) {
                this.appendContent(row, left, right.substr(0, this.viewModel.maxCharactersToDisplay) + SearchDescriptionViewModel.DOTS, value);
                return row;
            }

            this.appendContent(row, left, splitContent.slice(0, this.viewModel.maxWordsToDisplay).join(' ') + SearchDescriptionViewModel.DOTS, value);
            return row;
        }

        let minimizedCollection = this.viewModel.buildMinimizedContent(splitContent, value);
        const maximumReached = minimizedCollection.length > this.viewModel.maxEntriesToShow;

        const resultMessage = '<br><br><span>' + this.viewModel.moreEntriesFoundText.replace('%%MISSING%%', minimizedCollection.length - this.viewModel.maxEntriesToShow + '') + '</span>';
        minimizedCollection = maximumReached ? minimizedCollection.slice(0, this.viewModel.maxEntriesToShow) : minimizedCollection;

        this.appendContent(row, left, minimizedCollection.join(`<br><br>`) + `${maximumReached ? resultMessage : ''}`, value);

        return row;
    }

    private appendContent(row: JQuery<HTMLElement>, leftValue: string, rightValue: string, valueToHighlight: string) {
        this.buildContentForRow(leftValue).appendTo(row);
        this.buildContentForRow(rightValue).appendTo(row).highlight(valueToHighlight);
    }

    private buildContentForRow(value: string): JQuery<HTMLElement> {
        return $('<td>' + value + '</td>');
    }

    protected override repositionOverlay() {
        this.resultExpander = $(document).find('.result-expander');
        this.adjustTooltipPositionAndSize(this.widget());
    }

    public adjustTooltipPositionAndSize(widget:  kendo.ui.TooltipExt): void {
        //Mausposition noch nicht gesetzt oder der Tooltip hat keinen Inhalt (Tabelle)
        if (this.currentMouseX <= 0 || !widget?.content) return;

        const kendoContainer = widget.content.closest('.k-animation-container');
        if (!kendoContainer.length) return;

        const contentEl = widget.content[0];
        const mouseX = this.currentMouseX;
        const offset = 30;

        // Grenzen des resultExpander
        const expanderLeft = this.resultExpander.offset().left;
        const expanderRight = expanderLeft + this.resultExpander.outerWidth();
        const expanderWidth = expanderRight - expanderLeft;

        // Natuerliche Inhaltsgroesse messen, unabhaengig von vorherigen
        // Einschraenkungen (width/overflow) -> kein Reset noetig
        const naturalWidth = contentEl.scrollWidth;
        const naturalHeight = contentEl.scrollHeight;

        // Bei zu breitem Tooltip auf Expander-Breite begrenzen und
        // horizontales Scrollen ermoeglichen, sonst natuerliche Breite verwenden
        let tooltipWidth: number;
        if (naturalWidth >= expanderWidth) {
            tooltipWidth = expanderWidth;
            kendoContainer.outerWidth(expanderWidth);
            kendoContainer.css('overflow-x', 'auto');
            widget.content.css('min-width', 'max-content');

            //Unterdrueckt das Schlie�en des Tooltips beim Versuch mit der Maus den Tooltip in der breite zu scrollen
            kendoContainer
                .off('mousedown.tooltipScroll')
                .on('mousedown.tooltipScroll', (e) => e.stopPropagation());
        
        } else {
            tooltipWidth = kendoContainer.outerWidth();
        }

        // bevorzugt rechts vom Cursor, sonst links, sonst innerhalb des Expanders zentrieren
        let leftPosition: number;
        let calloutClass: string;

        const fitsRight = mouseX + offset + tooltipWidth <= expanderRight;
        const fitsLeft = mouseX - offset - tooltipWidth >= expanderLeft;

        if (fitsRight) {
            leftPosition = mouseX + offset;
            calloutClass = 'k-callout k-callout-w';
        } else if (fitsLeft) {
            leftPosition = mouseX - offset - tooltipWidth;
            calloutClass = 'k-callout k-callout-e';
        } else {
            leftPosition = expanderLeft + Math.max(0, (expanderWidth - tooltipWidth) / 2);
            calloutClass = 'k-callout k-callout-w';
        }

        // Nie weiter links als der Expander, nie weiter rechts hinaus
        leftPosition = Math.min(leftPosition, expanderRight - tooltipWidth);
        leftPosition = Math.max(leftPosition, expanderLeft);

        kendoContainer.css('left', leftPosition + 'px');
        kendoContainer.find('.k-callout').attr('class', calloutClass);

        // Vertikale Ausrichtung
        const expanderTop = this.resultExpander.offset().top;
        const expanderBottom = expanderTop + this.resultExpander.height();

        // Obere Wachstumsgrenze: Oberkante des Wrappers
        const growthBoundary = this.resultExpander.closest('[data-role=tooltip]');
        const upperLimitTop = growthBoundary.length
            ? growthBoundary.offset().top
            : expanderTop; // Fallback, falls der Wrapper nicht existiert

        // Gesamter verfuegbarer vertikaler Raum: von der Wrapper-Oberkante bis zur
        // Expander-Unterkante. Der Tooltip darf nach oben bis upperLimitTop wachsen
        // und nach unten bis expanderBottom.
        const availableHeight = expanderBottom - upperLimitTop;

        // Effektive Tooltip-Hoehe: natuerliche Hoehe, aber max. der verfuegbare Raum
        const effectiveHeight = Math.min(naturalHeight, availableHeight);

        // Schwellwert: ist die Maus nah am Ende des resultExpander?
        const nearBottomThreshold = expanderBottom - (effectiveHeight / 2);
        const isNearBottom = this.currentMouseY >= nearBottomThreshold;

        // Ausgangsposition cursornah bestimmen
        let topPosition = isNearBottom
            ? this.currentMouseY - effectiveHeight // nahe am Ende -> nach oben aufklappen
            : this.currentMouseY;                  // sonst -> nach unten aufklappen

        // Unterkante nicht unter den Expander schieben
        if (topPosition + effectiveHeight > expanderBottom) {
            topPosition = expanderBottom - effectiveHeight;
        }

        // Oberkante nicht ueber die Wachstumsgrenze (Wrapper-Oberkante) hinaus
        if (topPosition < upperLimitTop) {
            topPosition = upperLimitTop;
        }

        // Hoehe nur begrenzen, wenn der natuerliche Inhalt groesser als der
        // verfuegbare Raum ist -> dann scrollen
        if (naturalHeight > availableHeight) {
            kendoContainer.css({
                height: `${availableHeight}px`,
                overflowY: 'auto',
            });
        }

        kendoContainer.css('top', topPosition + 'px');
    }
}

ComponentManager.setControl('SearchDescription', SearchDescription, 'RADPresentation.HTMLClient.DefaultViewExtensions');